<template>
  <div>
    <div id="laiyuan">

    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  props: ["laiyuanList"],
  data() {
    return {};
  },
  watch: {
    laiyuanList(yuqingZhanbiDatas) {
      if (yuqingZhanbiDatas) {
        // console.log(yuqingZhanbiDatas);
        // let color = [
        //   "#1B8EFF",
        //   "#5CDBD3",
        //   "#F4222E",
        //   "#9254DE",
        //   "#f4b764",
        //   "#5c79e8"
        // ];
        // let arrName = [];
        // let arrValue = [];
        // let sum = 0;
        // let pieSeries = [],
        //   lineYAxis = [];
        // let chartData = [
        //   {
        //     name: "APP",
        //     value: yuqingZhanbiDatas.APP, //132,
        //     unit: "条"
        //   },
        //   {
        //     name: "论坛",
        //     value: yuqingZhanbiDatas.BBS, //421,
        //     unit: "条"
        //   },
        //   {
        //     name: "视频",
        //     value: yuqingZhanbiDatas.Video, //421,
        //     unit: "条"
        //   },
        //   {
        //     name: "新闻",
        //     value: yuqingZhanbiDatas.News, //421,
        //     unit: "条"
        //   },
        //   {
        //     name: "微信",
        //     value: yuqingZhanbiDatas.WeiXin, //421,
        //     unit: "条"
        //   },
        //   {
        //     name: "微博",
        //     value: yuqingZhanbiDatas.Micro, //421,
        //     unit: "条"
        //   }
        // ];

        // chartData.forEach((v, i) => {
        //   arrName.push(v.name);
        //   arrValue.push(v.value);
        //   sum = sum + v.value;
        // });
        // chartData.forEach((v, i) => {
        //   pieSeries.push({
        //     name: "舆情占比",
        //     type: "pie",
        //     clockWise: false,
        //     hoverAnimation: true,
        //     radius: [85 - i * 20 + "%", 77 - i * 20 + "%"],
        //     // radius: ["20%","30%"],
        //     center: ["50%", "50%"], //数据环
        //     label: {
        //       show: false
        //     },
        //     data: [
        //       {
        //         value: v.value * 0.75, //v.value
        //         name: v.name
        //       },
        //       {
        //         value: sum - v.value * 0.75, //sum - v.value
        //         name: "",
        //         itemStyle: {
        //           color: "rgba(0,0,0,0)"
        //         }
        //       }
        //     ]
        //   });
        //   pieSeries.push({
        //     name: "",
        //     type: "pie",
        //     silent: true,
        //     z: 1,
        //     clockWise: false, //顺时加载
        //     hoverAnimation: true, //鼠标移入变大
        //     radius: [85 - i * 20 + "%", 77 - i * 20 + "%"],
        //     center: ["50%", "50%"], //背景环的位置
        //     label: {
        //       show: false
        //     },
        //     data: [
        //       {
        //         value: 7.5,
        //         itemStyle: {
        //           color: "#E3F0FF"
        //         }
        //       },
        //       {
        //         value: 2.5,
        //         name: "",
        //         itemStyle: {
        //           color: "rgba(0,0,0,0)"
        //         }
        //       }
        //     ]
        //   });
        //   v.percent =
        //     ((v.value / sum) * 100).toFixed(1) == "NaN"
        //       ? 0 + "%"
        //       : ((v.value / sum) * 100).toFixed(1) + "%";
        //   lineYAxis.push({
        //     value: i,
        //     textStyle: {
        //       rich: {
        //         circle: {
        //           color: color[i],
        //           padding: [0, 5]
        //         }
        //       }
        //     }
        //   });
        // });
        // let yuqingZhanbiOption = {
        //   backgroundColor: "#fff",
        //   color: color,
        //   grid: {
        //     //指示线文字的位置设置
        //     top: "4.5%", //20%
        //     bottom: "35%", //54%
        //     left: "48%",
        //     containLabel: false
        //   },
        //   yAxis: [
        //     {
        //       type: "category",
        //       inverse: true,
        //       axisLine: {
        //         show: false
        //       },
        //       axisTick: {
        //         show: false
        //       },
        //       axisLabel: {
        //         formatter: function(params) {
        //           let item = chartData[params];
        //           return (
        //             "{line|}{circle|●}{name|" +
        //             item.name +
        //             "}{bd||}{percent|" +
        //             item.percent +
        //             "}{value|" +
        //             item.value +
        //             "}{unit|条}"
        //           );
        //         },
        //         interval: 0,
        //         inside: true,
        //         textStyle: {
        //           color: "#333",
        //           fontSize: 14,
        //           rich: {
        //             line: {
        //               width: 20,
        //               height: 10,
        //               backgroundColor: {
        //                 image:
        //                   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM8AAAAOBAMAAAB6G1V9AAAAD1BMVEX////Kysrk5OTj4+TJycoJ0iFPAAAAG0lEQVQ4y2MYBaNgGAMTQQVFOiABhlEwCugOAMqzCykGOeENAAAAAElFTkSuQmCC"
        //               }
        //             },
        //             name: {
        //               color: "#666",
        //               fontSize: 10
        //             },
        //             bd: {
        //               color: "#ccc",
        //               padding: [0, 5],
        //               fontSize: 10
        //             },
        //             percent: {
        //               color: "#333",
        //               fontSize: 10
        //             },
        //             value: {
        //               color: "#333",
        //               fontSize: 10,
        //               fontWeight: 500,
        //               padding: [0, 0, 0, 10]
        //             },
        //             unit: {
        //               fontSize: 10
        //             }
        //           }
        //         },
        //         show: true
        //       },
        //       data: lineYAxis
        //     }
        //   ],

        //   xAxis: [
        //     {
        //       show: false
        //     }
        //   ],
        //   series: pieSeries
        // };

        const color =[
          "#1B8EFF",
          "#5CDBD3",
          "#F4222E",
          "#9254DE",
          "#f4b764",
          "#5c79e8"
        ]
const data = [
          {
            name: "APP",
            value: 0, //132,
            unit: "条",
            Number:yuqingZhanbiDatas.APP,
          },
          {
            name: "论坛",
            value: 0, //421,
            unit: "条",
            Number:yuqingZhanbiDatas.BBS,
          },
          {
            name: "视频",
            value: 0, //421,
            unit: "条",
            Number: yuqingZhanbiDatas.Video,
          },
          {
            name: "新闻",
            value: 0, //421,
            unit: "条",
            Number:yuqingZhanbiDatas.News,
          },
          {
            name: "微信",
            value: 0, //421,
            unit: "条",
            Number:yuqingZhanbiDatas.WeiXin,
          },
          {
            name: "微博",
            value: 0, //421,
            unit: "条",
            Number:yuqingZhanbiDatas.Micro,
          }
        ];
let arrData=0
data.forEach((item)=>{
  arrData+=item.Number
})
data.forEach((item)=>{
  if(item.Number===0){
    item.value=0
  }else{
    item.value=(item.Number/arrData* 100).toFixed(2)
  }
  
  
})
const seriesForBg = {
	type: 'bar',
	name: 'bg',
	barCategoryGap: '50%',
	animation: false,
	data: data.map((d) => {
		return {
			name: d.name,
			value: arrData!==0?arrData:1,//防止总数为0时不显示图表
			itemStyle: {
				// color: 'rgba(27,36,62,0.5)'
				color: 'rgb(227 240 255)'
			}
		}
	}),
	coordinateSystem: 'polar',
	slient: true,
	center: ['65%', '50%']
}

const seriesForData = {
	type: 'bar',
	name: 'value',
	barGap: '-100%',
	barCategoryGap: '50%',
	data: data.map((d, i) => {
		return {
			name: d.name,
			value: d.Number,
			itemStyle: {
				color: color[i]
			}
		}
	}),
	coordinateSystem: 'polar',
	slient: true,
	center: ['65%', '50%']
}
let option = {
	angleAxis: {
		max: arrData,
		axisLine: {
			show: false,
		},
		axisTick: {
			show: false
		},
		axisLabel: {
			show: false
		},
		splitLine: {
			show: false
		},
		splitArea: {
			show: false
		}
	},
	radiusAxis: {
		type: 'category',
		data: data.map(d => {
      // console.log(d.name + ','+ d.Number + '条'+ (d.value)+'%');
			return d.name + ','+ d.Number + '条'+ (d.value)+'%'
			// return d.name + ','+ d.value + '条'
		}),
		z: 10,
		axisLine: {
			show: false,
		},
		axisTick: {
			length: 95,
			alignWithLabel: true,
			lineStyle: {
				type: 'solid'
			}
		},
		axisLabel: {
			show: true,
			showMinLabel: true,
			showMaxLabel: true,
			interval: 0,
			align: 'center',
			margin: 140,
			padding: 4,
			width: 100,
			fontSize: 12,
			borderWidth: 1,
			formatter: (value) => {
				const v = value.split(',')
				return '{c|' + v[1] + '} {b|' + v[0] + '}{r|}{a|}'
			},
			rich: {
				a: {
					width: 9,
					height: 10,
					backgroundColor: '#1F3E79',
					border: 1
				},
				r: {
					width: 1,
					height: 10,
					backgroundColor: '#1F3E79'
				},
				b: {
					color: '#58B7DE',
					borderColor: '#1F3E79',
					// borderWidth: 1,
					width: 30,
					// height: 20,
					// lineHeight: 20,
					align: 'center',
					fontSize: 12,
					fontFamily: 'Microsoft Yahei',
          // margin:20
				},
				c: {
					color: '#97ADBA',
					fontSize: 12,
					verticalAlign: 'bottom'
				},
			},
		},
		splitLine: {
			show: false,
			interval: 0,
		},
		splitArea: {
			show: false,
			alignWithLabel: true,
			interval: 0,
			areaStyle: {
				// color: ['rgba(125,125,125,0.3)', 'rgba(255,255,255,0.3)'],
			},
		},
	},
	polar: {
		center: ['65%', '50%']
	},
	series: [
    
		seriesForBg,
		seriesForData
	]
}

        setTimeout(() => {
          var chartDom = document.getElementById("laiyuan");
          var myChart = echarts.init(chartDom);
          // yuqingZhanbiOption && myChart.setOption(yuqingZhanbiOption);
          option && myChart.setOption(option);
        }, 1000);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#laiyuan {
  width: 100%;
  height: 100%;
}
</style>